import { useRef, useState } from 'react';

import NextLink from 'next/link';
import moment from 'moment';

import { ArrowLeftNRight, LeftLine } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import Button from '@components/Button';
import {
  CAR_RENTAL_SEARCH_DATE_FORMAT,
  formatMomentDate,
} from '@utils/dateUtil';
import {
  DEFAULT_CAR_RENTAL_DROP_OFF_DATE,
  DEFAULT_CAR_RENTAL_PICK_UP_DATE,
} from '@page/carRental/list/constants';
import { useSearchParamsToQuery } from '@hooks/useSearchParamsToQuery';
import useSearchBar from '@contexts/searchbar';
import { getVehicleName } from '@domain/carRental/utils';
import { useBreakpoint } from '@contexts/breakpoints';

import {
  ArrivalDetail,
  BottomHeaderContent,
  ContentWrapper,
  DetailContent,
  IconWrapper,
  MenuContent,
  Wrapper,
  Drawer,
} from './styled';
import HeaderSearch from './headerSearch';
import CarRentalHomeSearchBarContent, { ICarSearchBarHandle } from '..';

const SearchbarHeader = () => {
  const CarRentalSearchBarRef = useRef<ICarSearchBarHandle>(null);
  const query = useSearchParamsToQuery();
  const { xl: isDesktop } = useBreakpoint();
  const {
    state: { car: state },
  } = useSearchBar();

  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);

  const handleDrawerOpen = () => setIsDrawerOpen((oldState) => !oldState);

  const dep = getVehicleName(state?.pickUpLocation);
  const arr = getVehicleName(state?.dropOffLocation);
  const title = dep + ' - ' + arr;

  const ddate = `${
    query?.pickUpDate ||
    formatMomentDate(
      DEFAULT_CAR_RENTAL_PICK_UP_DATE,
      CAR_RENTAL_SEARCH_DATE_FORMAT
    )
  }`;
  const formatDdate = ddate && moment(ddate).format('DD MMMM');

  const rdate = `${
    query?.dropOffDate ||
    formatMomentDate(
      DEFAULT_CAR_RENTAL_DROP_OFF_DATE,
      CAR_RENTAL_SEARCH_DATE_FORMAT
    )
  }`;
  const formatRdate =
    rdate && rdate !== undefined ? moment(rdate)?.format('DD MMMM') : '';

  const handleSubmit = () => {
    CarRentalSearchBarRef?.current?.triggerHandleSubmit();
  };

  return (
    <>
      {!isDesktop && (
        <Wrapper>
          <ContentWrapper>
            <BottomHeaderContent>
              <IconWrapper>
                <NextLink href='/' passHref>
                  <CustomIcon
                    fontSize={24}
                    icon={LeftLine}
                    paletteColor='whiteAlpha600'
                  />
                </NextLink>
              </IconWrapper>
              <DetailContent>
                {dep !== arr ? (
                  <MenuContent>
                    {dep}{' '}
                    <CustomIcon
                      fontSize={16}
                      icon={ArrowLeftNRight}
                      paletteColor='whiteAlpha600'
                    />
                    {arr}
                  </MenuContent>
                ) : (
                  <MenuContent>{dep} </MenuContent>
                )}
                <ArrivalDetail>
                  {formatDdate}-{formatRdate}
                </ArrivalDetail>
              </DetailContent>

              <MenuContent>
                <HeaderSearch
                  toogleMenuOpen={handleDrawerOpen}
                  isOpen={isDrawerOpen}
                />
                <Drawer
                  title={title}
                  visible={isDrawerOpen}
                  onClose={handleDrawerOpen}
                  placement='top'
                  footer={
                    <Button block onClick={handleSubmit}>
                      Araç Ara
                    </Button>
                  }
                >
                  <CarRentalHomeSearchBarContent
                    handleDrawerOpen={handleDrawerOpen}
                    ref={CarRentalSearchBarRef}
                    page='listing'
                  />
                </Drawer>
              </MenuContent>
            </BottomHeaderContent>
          </ContentWrapper>
        </Wrapper>
      )}
    </>
  );
};

export default SearchbarHeader;
